
<div class="skeleton-loader">
  @if (show_avatar) {
    <div class="skeleton skeleton-avatar"></div>
  }
  @if (show_line) {
    <div class="skeleton skeleton-line"></div>
  }
  @if (show_line2) {
    <div class="skeleton skeleton-line short"></div>
  }
</div>